import {paymentsService, externalCardsService} from "@/modules/payments/services";

const state = {
  vaultedCards: [],
  cardRequest: null,
};

const getters = {
  vaultedCards: (state) => state.vaultedCards.filter(card => card.usage_permission === 'staff' || card.usage_permission === 'all'),
  clientScopeVaultedCards: (state) => state.vaultedCards.filter(card => card.usage_permission === 'client'),
  cardRequest: (state) => state.cardRequest,
};

const mutations = {
  setVaultedCards(state, cards) {
    state.vaultedCards = cards
  },
  setCardRequest(state, cardRequest) {
    state.cardRequest = cardRequest
  }
}

const actions = {
  async loadVaultedCards({commit, state}, clientUid) {
    let cards = (await paymentsService.getCreditCards(clientUid)).cards
    commit('setVaultedCards', cards)
    return cards;
  },
  async saveExternalCard({commit, state}, {clientId, token, cardholderName}) {
    let response = await externalCardsService.saveExternalCard(clientId, token, cardholderName)
    commit('setVaultedCards', [...state.vaultedCards, response.data.card])
    return response;
  },
  async updateSavedCardScope({commit, state}, {cardId, scope}) {
    try {
      const response = await externalCardsService.updateCardScope(cardId, scope)
      const updatedCardIndex = state.vaultedCards.findIndex(card => card.id === response.data.card.id)
      state.vaultedCards[updatedCardIndex] = response.data.card
      commit('setVaultedCards', [...state.vaultedCards])
      return response;
    } catch (error) {
      return error;
    }
  },
  async loadCardRequest({commit, state}, clientUid) {
    try {
      const response = await externalCardsService.fetchCardRequest(clientUid);
      commit('setCardRequest', response.data.card_request);
      return response;
    } catch (error) {
      commit('setCardRequest', null);
      return error;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
